"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.caseCheckAsyncRecipe = void 0;
const utils_1 = require("../utils");
const prepare_1 = require("../types-internal/prepare");
function caseCheckAsyncRecipe(ifTrue, ifFalse, defaultPredicate, predicateTransform = utils_1.identity) {
    return async function (givenPredicate = defaultPredicate) {
        const predicate = predicateTransform((0, prepare_1.prepare)(givenPredicate));
        for await (const t of this) {
            if (await predicate(t)) {
                return ifTrue(t);
            }
        }
        return ifFalse;
    };
}
exports.caseCheckAsyncRecipe = caseCheckAsyncRecipe;
